import { languageIdBus } from "@/event/languageIdBus";
import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy";
import type { Option } from "@/storage/products";
import { getOptionNameById } from "@/utils/product/getOptionNameById";

export function initializeOptionIfNeeded(option: Option) {
    const optionId = option.option_id
    if (!selectOptionsListHappy.value[optionId]) {
        selectOptionsListHappy.value[optionId] = {
            option_id: optionId,
            name_option: getOptionNameById(optionId, languageIdBus.value) || '',
            required: option?.required || false,
            selected_values: {
                radio_option: {
                    option_value_id: 0,
                    option_value_name: '',
                    option_value_image: '',
                    option_value_price: ''
                },
                checkbox_option: {
                    option_value_free: [],
                    option_value_paid: [],
                    quantity_free: option.free_option_count || 0,
                    quantity_paid: Math.max(0, option.max_option_count - option.free_option_count)
                }
            }
        }
    }
}